module.exports = __webpack_public_path__ + "img/sr.ca03b3b4.svg";